import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';
import { AdjustmentsAuditComponent } from './adjustments-audit.component';

const routes: Routes = [
    {
        path: 'adjustments-audit',
        component: AdjustmentsAuditComponent,
        canActivate: [AuthGuard, AdminGuard],
        data: { title: 'Home Leite - Auditoria de ajustes' }
    }
];

export const AdjustmentsAuditRoutes = RouterModule.forChild(routes);
